<template>
    <div></div>
</template>
<script>

import { mapState } from 'vuex'
import AuthService from '@/modules/authentication/services/auth.service'

export default {
    name: 'Dashboard',
    computed: {
        ...mapState({
            token: state => state.auth.token
        })
    },
    watch: {
        token: {
            immediate: true,
            handler: function (token) {
                if (token) {
                    AuthService.getProfile().then(
                        result => {
                            this.$store.commit(this.$actionTypes.auth.PROFILE, result.data)
                            this.$appService.loadThenSelectProject(true)
                        }
                    )
                }
            }
        }
    }
}
</script>
